// Rule display reasons (static copy, ordered by severity)
const RULE_DISPLAY = {
  flag_urgent_status: {
    reason: 'EHR flagged as urgent',
    severity: 1,
  },
  flag_concerning_status: {
    reason: 'EHR status needs attention',
    severity: 1,
  },
  callouts_high_risk: {
    reason: 'EHR flagged high risk',
    severity: 1,
  },
  callouts_medium_risk: {
    reason: 'EHR flags present',
    severity: 3,
  },
  med_adherence_risk: {
    reason: 'Medication adherence risk',
    severity: 2,
  },
  overdue_appointment: {
    reason: 'Overdue for appointment',
    severity: 2,
  },
  escalate_no_response: {
    reason: 'No response after multiple attempts',
    severity: 3,
  },
  missed_visits_flag: {
    reason: 'Missed multiple appointments',
    severity: 3,
  },
};

// Get display reasons for triggered rules (max 2, ordered by severity)
export const getTriggeredReasons = (triggeredRules) => {
  if (!triggeredRules || !Array.isArray(triggeredRules) || triggeredRules.length === 0) {
    return [];
  }

  return triggeredRules
    .filter(code => RULE_DISPLAY[code])
    .map(code => ({ code, ...RULE_DISPLAY[code] }))
    .sort((a, b) => a.severity - b.severity)
    .slice(0, 2)
    .map(r => r.reason);
};

export default RULE_DISPLAY;
